/**
 * @desc 生成补货计划
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(
  params: API.wms.demandOrder.generateReplenishmentPlan.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/wms/demandOrder/generateReplenishmentPlan`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
